/**
 * Dependencies
 */
import React from 'react';
import { Box } from '@nerdwallet/currency';
import DocumentTitle from 'react-document-title';

// Local Components
import VerticalComparison from '../components/front-page/vertical-comparison/vertical-comparison';
import CCBest from '../components/front-page/cc-best/cc-best';
import Testimonials from '../components/front-page/testimonials/testimonials';
import RegistrationModule from '../components/front-page/registration-module/registration-module';
import CampaignHighlight from '../components/front-page/campaign-highlight/campaign-highlight';
import NewsArticles from '../components/front-page/news-articles/news-articles-container/news-articles-container';

// Other Local Dependencies
import {
  verticalComparisonContent,
  ccBestContent,
  testimonialsContent,
  registrationModuleContent,
  campaignHighlightContent,
} from '../lib/front-page-content';

const FrontPage = () => {
  const documentTitle = 'NerdWallet: Make all the right money moves';

  return (
    <React.Fragment>
      <DocumentTitle title={documentTitle} />
      <Box marginTop={4}>
        <VerticalComparison {...verticalComparisonContent} />
      </Box>
      <RegistrationModule {...registrationModuleContent} />
      <Testimonials {...testimonialsContent} />
      <CampaignHighlight {...campaignHighlightContent} />
      <Box marginY={{ mobile: '2', desktop: '3' }}>
        <NewsArticles />
      </Box>
      <CCBest {...ccBestContent} />
    </React.Fragment>
  );
};

FrontPage.displayName = 'FrontPage';
FrontPage.analyticsName = 'nw_home_page';
FrontPage.segmentPageName = 'homepage';

FrontPage.propTypes = {};

export default FrontPage;
